module.exports = __webpack_public_path__ + "static/worker-get-paid-b684cb55524f15b8e1a8deddd10e7229.png";